import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, of, finalize, map } from 'rxjs';

import { LoadingService } from '../../../../core/services/loading.service';
import { ReportsService } from '../../../../core/services/reports.service';
import { StudentDetailResult } from '../../../../core/models/student.model';
import { SessionStorageService } from '../../../../core/services/session-storage.service';
import { SubscriptionTypes } from '../../../../core/models/subscription-types.model';

export const detailResolver: ResolveFn<StudentDetailResult> = (route, state) => {
  const reportsService = inject(ReportsService);
  const loadingService = inject(LoadingService);
  const sessionStorageService = inject(SessionStorageService);
  const isSystem = (route.paramMap.get('product') ?? '') === SubscriptionTypes.FullProduct.toLowerCase() ;
  const diagnosticOpts = (sessionStorageService.getDiagnosticOpts() ?? {})[isSystem ? SubscriptionTypes.FullProduct : SubscriptionTypes.Diagnostic] ;
  const studentIdParam = route.paramMap.get('userid');
  const studentId = Number(studentIdParam);

  loadingService.start();

  // Make sure we can get the student data
  if (!studentIdParam || Number.isNaN(studentId))
  {
    loadingService.finish();
    return of({
      status: 'error' as const,
      error: new Error('Invalid student ID'),
    });
  }

  return reportsService.getStudentDiagnosticData(studentId, isSystem).pipe(
    map((student) => {
      // For the detailed view, we need to make sure the diagnostics we show correspond to the
      // filtering on the main results page. We also in this context want to limit our scores so they
      // are in displayable ranges to show the user
      student.assessmentScores = (student.assessmentScores ?? []).filter(score =>
        (!diagnosticOpts.testWindow && !diagnosticOpts.compareWindow) ||
        ((diagnosticOpts.testWindow ?? '').toLowerCase() === 'all tests') ||
        score.testWindow === diagnosticOpts.testWindow ||
        (diagnosticOpts.showCompare && score.testWindow === diagnosticOpts.compareWindow)
      ) ;

      reportsService.processStudentsAssessmentScores([ student ], {}, {}, {}) ;

      return {
        status: 'success' as const,
        student,
      } ;
    }),
    catchError(error => {
      return of({
        status: 'error' as const,
        error,
      })
    }),
    finalize(() => loadingService.finish())
  );
};
